<template>
  <div class="list" ref="list">
    <div class="row gy-4">
      <div
        v-for="post in $store.state.posts"
        class="col-lg-3 col-md-6 col-mini"
        :key="post.id"
      >
        <Loader v-if="post.type == 'loader'" />
        <SuccessStorie v-else-if="post.type == 'success-storie'" :post="post" />
        <Event v-else-if="post.type == 'event'" :post="post" />
        <Whitepaper
          v-else-if="
            post.type == 'whitepaper' ||
            post.type == 'partner' ||
            post.type == 'expertise' ||
            post.type == 'playground' ||
            post.type == 'solution' ||
            post.type == 'service' ||
            post.type == 'product' ||
            post.type == 'industry'
          "
          :post="post"
        />
        <NewsPR
          v-else-if="post.type == 'news-and-pr' || post.type == 'page'"
          :post="post"
        />
        <ExpertView v-else-if="post.type == 'expert-view'" :post="post" />
        <Training v-else-if="post.type == 'training'" :post="post" />
        <BookView v-else-if="post.type == 'book'" :post="post" />
        <People v-else-if="post.type == 'people'" :post="post" />
        <Podcast v-else-if="post.type == 'podcast'" :post="post" />
        <WebinarOnDemand
          v-else-if="post.type == 'webinar-on-demand'"
          :post="post"
        />
        <Mini v-else :post="post" />
      </div>
    </div>

    <div
      class="row mt-5"
      v-if="!$store.state.isLoading && $store.state.posts.length > 0"
    >
      <div class="col text-center">
        <button
          class="btn btn-link"
          type="button"
          v-html="$store.state.i18n.discover_more"
          @click="load_more()"
          v-if="$store.state.currentPage < $store.state.wp_totalpages"
        ></button>

        <Compteur v-if="$store.state.page_type != 'search'" />
      </div>
    </div>

    <div v-if="!$store.state.isLoading && $store.state.posts.length == 0">
      <h1>No results</h1>
    </div>
  </div>
</template>

<script>
import Loader from "./mini/Loader.vue";
import SuccessStorie from "./mini/SuccessStorie.vue";
import Event from "./mini/Event.vue";
import Whitepaper from "./mini/Whitepaper.vue";
import NewsPR from "./mini/NewsPR.vue";
import ExpertView from "./mini/ExpertView.vue";
import Training from "./mini/Training.vue";
import People from "./mini/People.vue";
import WebinarOnDemand from "./mini/WebinarOnDemand.vue";
import Mini from "./mini/Mini.vue";
import Compteur from "./parts/Compteur.vue";
import BookView from "./mini/BookView.vue";
import Podcast from "./mini/Podcast.vue";

export default {
  name: "List",
  components: {
    Compteur,
    Mini,
    Loader,
    SuccessStorie,
    Event,
    Whitepaper,
    NewsPR,
    ExpertView,
    Training,
    People,
    WebinarOnDemand,
    BookView,
    Podcast,
  },

  methods: {
    load_more: function () {
      this.$store.dispatch("discoverMore");
    },
  },
};
</script>
